// Humanise raw codename-style values (e.g. "ice_water_barrier" -> "Ice Water Barrier")
// for detail-card badge display. Already-humanised values like "Standard" pass through.
export function humaniseBadge(value: string): string {
  if (!value.includes("_") && /[A-Z]/.test(value)) return value;
  return value
    .replace(/_/g, " ")
    .replace(/\b\p{L}/gu, (c) => c.toUpperCase());
}
